import theme from 'config/theme';
import Icon, { IconNames } from 'components/Icon';
import { useAppSelector } from 'helpers/hooks';
import { getUserId } from 'selectors/user';
import { trackEvent } from 'helpers/mixpanelEvents';
import { AlertBellWrapper, TooltipText } from './styled';

const MANAGE_ALERTS_PATH = '/forms/manage-alerts';

export const AlertBell = ({ color }: { color?: string }) => {
  const userId = useAppSelector(getUserId);

  const handleClick = () => {
    window.open(MANAGE_ALERTS_PATH, '_blank');
    trackEvent('Alert Bell Clicked', { ...(userId && { user_id: userId }) });
  };

  return (
    <AlertBellWrapper onClick={handleClick}>
      <Icon name={IconNames.Bell} color={color || theme.colors.white} size={16} />
      <TooltipText>Want to be notified if this page is updated?</TooltipText>
    </AlertBellWrapper>
  );
};
